import { Col, Flex } from 'antd';
import get from 'lodash/get';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { updateUser } from '@tools/ui/api';
import { IconSize, IconType, IconWrap, semanticTheme } from '@tools/ui/dime';
import { TModules, User } from '@tools/ui/types';
import { userStore } from '@tools/ui-stores';

const Layout = styled.div`
  margin-left: 10px;
`;

const NameCol = styled(Col)<Pick<IProps, 'isActive'>>(({ isActive }) => ({
  fontWeight: isActive ? 600 : 400,
  color: semanticTheme.dime.colors.text.primary,
  maxWidth: '160px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

const IconContainer = styled.div`
  opacity: 0;
  cursor: pointer;
  z-index: 1000;

  ${Layout}:hover & {
    opacity: 1;
  }
`;

type IProps = {
  menuModule: TModules;
  isFavorite: boolean;
  isActive: boolean;
};

export const MenuModuleContact: FC<React.PropsWithChildren<IProps>> = observer(
  ({ menuModule, isFavorite, isActive }: IProps) => {
    const { currentUser } = userStore;

    const favoriteClicked = async (e) => {
      e.preventDefault();
      const updatedFavoriteModules = currentUser?.favoriteModules ?? [];

      const moduleIndex = updatedFavoriteModules.indexOf(menuModule.path);
      if (moduleIndex > -1) {
        updatedFavoriteModules.splice(moduleIndex, 1);
      } else {
        updatedFavoriteModules.push(menuModule.path);
      }

      userStore.setUser({
        ...currentUser,
        favoriteModules: updatedFavoriteModules,
      } as User);

      await updateUser({
        _id: currentUser!._id,
        favoriteModules: updatedFavoriteModules,
      });
    };

    return (
      <Layout>
        <NavLink to={get(menuModule.routes, '[1].path', menuModule.path)}>
          <Flex justify={'space-between'}>
            <NameCol isActive={isActive} title={menuModule.name}>
              {menuModule.name}{' '}
            </NameCol>
            <IconContainer onClick={favoriteClicked}>
              <IconWrap
                size={IconSize.Small}
                type={isFavorite ? IconType.PinFilled : IconType.PinEmpty}
              />
            </IconContainer>
          </Flex>
        </NavLink>
      </Layout>
    );
  },
);
